/** @format */

const template = `
<div class="row">
  <div class="col-12">
    <div class="row" ng-if="$ctrl.selectionPathInPlan.noDuplicates === false">
      <div class="col-md-12">
        <sis-contextual-notification variant="warning">
          <span translate="PLAN_STUDY_RIGHT_STATE.DUPLICATE_SELECTION_BANNER_TITLE"></span>
        </sis-contextual-notification>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="state-credits-header float-end">
          <div class="module-grade-average-header">
            <h4 translate>SIS_COMPONENTS.PLAN.LABEL.GRADE_AVERAGE</h4>
          </div>
          <div class="module-state-header">
            <h4 translate>SIS_COMPONENTS.PLAN.LABEL.STATE</h4>
          </div>
          <div class="module-credits-header">
            <h4 translate>SIS_COMPONENTS.PLAN.LABEL.TARGET_CREDITS</h4>
            <div class="sub-headers">
              <span translate>SIS_COMPONENTS.PLAN.LABEL.SELECTED_CREDITS</span>
              <span class="credits-done" translate>SIS_COMPONENTS.PLAN.LABEL.ATTAINED</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div ng-if="$ctrl.ready" class="row">
      <div class="col-md-12">
        <div class="accordion-panel accordion-panel-noblock-dotted-content" ng-class="{'open': $ctrl.isOpen}">
          <div class="header has-header-items">
            <button
              type="button"
              class="collapse non-button"
              ng-click="$ctrl.isOpen = !$ctrl.isOpen"
              ng-class="{collapsed: !$ctrl.isOpen}"
              tabindex="0"
              aria-label="{{:: $ctrl.education.name | localizedString}}"
              aria-expanded="{{$ctrl.isOpen}}">
              <sis-icon icon="chevron-ring-fill" [icon-class]="!$ctrl.isOpen ? null : 'cw-90'"></sis-icon>
            </button>
            <div class="title">
              <sis-tooltip [append-to-body]="true" tooltip-class="tooltip-wide">
                <span class="sis-tooltip-trigger-content" aria-label="{{$ctrl.titleAriaLabel}}"
                  ><span aria-hidden="true">{{:: $ctrl.education.name | localizedString }}</span></span
                >
                <div class="sis-tooltip-content">
                  <div class="plan-structure-study-tooltip">
                    <div class="study-name">{{:: $ctrl.education.name | localizedString }}</div>
                    <div class="first-level"
                      >{{:: 'SIS_COMPONENTS.PLAN.EDUCATION_TOOLTIP.VALIDITY_PERIOD' | translate }} {{:: $ctrl.education.validityPeriod |
                      localDateRange }}</div
                    >
                  </div>
                </div>
              </sis-tooltip>
              <span class="additional">
                <span
                  ng-if="$ctrl.education.documentState != 'ACTIVE'"
                  class="tiny-badge"
                  ng-class="{'accent': $ctrl.education.documentState == 'DRAFT',
                                 'secondary': $ctrl.education.documentState == 'DELETED'}"
                  translate="{{'DOCUMENT_STATE.'+$ctrl.education.documentState}}">
                </span>
                {{:: $ctrl.education.code }}
              </span>
            </div>
            <div class="title-line">
              <div class="title-line-liner"></div>
            </div>
            <ng-container ng-if="$ctrl.educationValidationResults.state!='ATTAINED'">
              <div class="cell status">
                <div class="state-invalid" ng-if="$ctrl.educationValidationResults.state === 'INVALID'">
                  <sis-icon icon="alert-fill"></sis-icon>
                  <span translate="SIS_COMPONENTS.PLAN_STATE.INVALID">sääntöjen vastainen</span>
                </div>
                <div ng-if="$ctrl.educationValidationResults.state !== 'INVALID'" class="state">
                  {{::'SIS_COMPONENTS.PLAN_STATE.' + $ctrl.educationValidationResults.state|translate}}
                </div>
              </div>
              <div class="cell module-credits"></div>
            </ng-container>
          </div>

          <div class="content animate-if" ng-if="$ctrl.isOpen" ng-class="{collapsed: !$ctrl.isOpen}">
            <div class="content-row">
              <div class="content-text">
                <common-plan-module
                  ng-repeat="module in $ctrl.childModuleSelections track by module.id"
                  plan="$ctrl.plan"
                  module-id="module.id"
                  parent-module-id="$ctrl.education.id"
                  course-unit-attainments="$ctrl.courseUnitAttainments"
                  plan-validation-result="$ctrl.planValidationResult"
                  validatable-plan="$ctrl.validatablePlan"
                  module-content-approvals="$ctrl.moduleContentApprovals"
                  highlighted-module-id="$ctrl.highlightedModuleId"
                  education-options="$ctrl.educationOptions"
                  show-implicit-selections="true"
                  show-action-button-column="true">
                </common-plan-module>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
`;
export default template;
